/**
 * 封装多个社交平台的分享API
 * wiki: https://wiki.pengpengla.com/pages/viewpage.action?pageId=13369645
 */

import Share from '../deps/share-client';

const platform = Uplib.native.getPlatform();
const system = Uplib.native.getSystem();
// 中东地区国家码
const middelEastCountryCodes = ['EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PK', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'UG', 'YE'];

let defaultCfg = {
	// 客户端3.0.0 ins和message 还未集成
	
	channelsForIOS: {
		// 大陆 微信好友 微信朋友圈  微博  QQ好友 QQ空间 
		'CN': ['wechat_friends', 'wechat_circle', 'sina', 'qq','qzone' ],
		// 台湾 FB  Messenger  Line  Twitter Instagram Whatsapp  微信好友 微信朋友圈
		'TW': ['fb', 'line', 'tw', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 越南 FB  Messenger  Twitter Instagram Whatsapp 微信好友 微信朋友圈
		'VN': ['fb', 'tw', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 日本 FB  Messenger  Twitter Instagram Line 微信好友 微信朋友圈
		'JP':  ['fb', 'tw', 'line', 'wechat_friends', 'wechat_circle'],
		// 香港 FB  Messenger Whatsapp 微信好友 微信朋友圈  Twitter  Instagram Line  QQ好友 QQ空间
		'HK': ['fb', 'whatsapp',  'wechat_friends', 'wechat_circle', 'tw', 'line', 'qq','qzone'],
		// 中东 FB Messenger  Twitter Instagram Whatsapp
		'MSL': ['fb', 'tw', 'whatsapp'],
		// 澳门 FB  Messenger  Twitter Instagram  微信好友 微信朋友圈
		'MO':  ['fb', 'tw', 'wechat_friends', 'wechat_circle'],
		// 泰国：FB Messenger Twitter Instagram Line Whatsapp 微信好友 微信朋友圈
		'TH': ['fb', 'tw', 'line', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 印尼：FB Messenger Line  Twitter Instagram Whatsapp 微信好友 微信朋友圈
		'ID': ['fb', 'line','tw', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 马来西亚： FB Messenger 微信好友 微信朋友圈 Whatsapp Line Instagram
		'MY': ['fb', 'wechat_friends', 'wechat_circle', 'whatsapp', 'line'],
		// 新加坡： FB  Messenger Twitter Instagram Whatsapp 微信好友 微信朋友圈  line（安卓2.8.0版本增加，iOS已增加）
		'SP': ['fb', 'tw', 'whatsapp', 'wechat_friends', 'wechat_circle', 'line'],
		// 韩国：kakao（安卓2.8.0版本、iOS2.6.0版本） Line FB  Messenger  Twitter Instagram Whatsapp 微信好友 微信朋友圈
		'KR': ['kakao', 'line', 'fb', 'tw', 'whatsapp', 'wechat_friends', 'wechat_circle',],
		// 其他：FB  Messenger  Twitter Instagram Whatsapp Line 微信好友 微信朋友圈
		'All': ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "whatsapp", "line", "kakao"],
	},
	channelsForAndroid: {
		// 大陆
		'CN': ['wechat_friends', 'wechat_circle', 'sina', 'qq','qzone' ],
		// 台湾
		'TW': ['fb', 'messenger', 'line', 'tw', 'ins', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 越南
		'VN': ['fb', 'messenger', 'tw', 'ins', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 日本
		'JP':  ['fb', 'messenger', 'tw', 'ins', 'line', 'wechat_friends', 'wechat_circle'],
		// 香港
		'HK': ['fb', 'messenger', 'whatsapp',  'wechat_friends', 'wechat_circle', 'tw', 'ins', 'line', 'qq','qzone'],
		// 中东
		'MSL': ['fb', 'messenger', 'tw', 'ins', 'whatsapp'],
		// 澳门
		'MO':  ['fb', 'messenger', 'tw', 'ins', 'wechat_friends', 'wechat_circle'],
		// 泰国
		'TH': ['fb', 'messenger', 'tw', 'ins', 'line', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 印尼
		'ID': ['fb', 'messenger', 'line', 'tw', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 马来西亚
		'MY': ['fb', 'messenger', 'wechat_friends', 'wechat_circle', 'whatsapp', 'line', 'ins'],
		// 新加坡
		'SP': ['fb', 'messenger', 'tw', 'ins','whatsapp', 'wechat_friends', 'wechat_circle', 'line'],
		// 韩国
		'KR': ['kakao', 'line', 'fb', 'messenger', 'tw', 'ins', 'whatsapp', 'wechat_friends', 'wechat_circle'],
		// 全部
		'All': ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"],
	},
	complete: ()=>{}
}

const shareMask = {
	init() {
		if (platform == 'uplive') {
			this.shareUplive();
		}
	},
	/**
	 * 在Upliveke客户端中分享
	 */
	shareUplive() {
		let channelsCfg = {};
		let channels = [];
		
		if (system == 'android') {
			channelsCfg = defaultCfg.channelsForAndroid;
		} else {
			channelsCfg = defaultCfg.channelsForIOS;
		}
		if (middelEastCountryCodes.indexOf(defaultCfg.countryCode) > -1) {
			channels = channelsCfg['MSL'];
		} else {
			channels = channelsCfg[defaultCfg.countryCode || 'All'];
		}


		let nshare  = new Share({
			channels,
			shareData: defaultCfg.data,
			complete: defaultCfg.complete
		});

		nshare.show();
	}
}

const _init = function(options) {
    options = options || {};

    defaultCfg = Object.assign(defaultCfg, options);

    shareMask.init();
}

const share = function(cfg) {
	_init.apply(shareMask, arguments);

	return shareMask;
}

UpSDK.share = share;


// WEBPACK FOOTER //
// ./src/js/openjs/uph5/share.js